import { useMemo, useRef, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
// img
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CLIENT_REPORTS_LIST, SCHOOL_CLIENT_DETAIL } from "config/paths";
import { Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, getAge, getPdfBlob, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import { ASSESSMENT_REPORT_V2_QUESTIONS, CLIENT_REPORT_TYPES, dobFormat, REPORT_IDS, reportDateFormat } from "config/constants";
import moment from "moment";
import ReportError from "components/shared/ReportsV2/ReportError";
import GuardianDetailList from "components/shared/ReportsV2/GuardianDetailsList";
import { useGetDisciplineAreasQuery, useUploadFileMutation } from "store/services/utility";
import { useCopyReportsMutation, useGetReportClientsAssessmentFeedbackQuery, useSubmitAssessmentReportMutation } from "store/services/clients/reports-v2/schoolReports";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import ClientDetails from "components/shared/ReportsV2/ClientDetails";
import { ArrowLeftIcon } from "Assets/icons";
import RenderQuestion from "components/shared/ReportsV2/Questions/Index";
import { formatReportFeedbackV2, reportInitialValuesV2 } from "helpers/assessment";
import QuestionMultipleRecommendation from "components/shared/ReportsV2/Questions/QuestionMultipleRecommendation";
import { toPng } from "html-to-image";
import getValidationSchema from "./validation";
import { cloneDeep, isEmpty } from "lodash";
import TabStepper from "components/shared/ReportsV2/TabStepper";
import QuestionAssessments from "components/shared/ReportsV2/Questions/QuestionAssessments";
import QuestionTreatmentPlan from "components/shared/ReportsV2/Questions/QuestionTreatmentPlan";
import ReportSubmitButton from "components/shared/ReportsV2/ReportSubmitButton";
import AssessmentReportDocV2 from "components/PDF/Clients/ReportsV2/AssessmentReportDocV2";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import AutosaveReport from "components/shared/ReportsV2/AutosaveReport";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import confirmDialogV2 from "utils/confirmationDialogV2";
import ApprenticeSelect from "components/shared/ReportsV2/ApprenticeSelect";

const SchoolAssessmentReport = () => {
  const navigate = useNavigate();
  const sliderRefs = useRef([]);
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [goalSubmissionError, setGoalSubmissionError] = useState(null);
  const [chartImages, setChartImages] = useState(null);
  const { assessmentId, clientId, reportId } = useParams();
  const clientType = "school"
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null)

  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.INDIVIDUAL_SESSION_REPORT_V2]?.title);
  const [publishPdfModal, setPublishPdfModal] = useState(false)

  const [submitReport, { isLoading: submitReportLoading }] = useSubmitAssessmentReportMutation();
  const [copyReport, { isLoading: copyReportLoading }] = useCopyReportsMutation()
  const { data, isLoading, isFetching, isError, refetch } = useGetReportClientsAssessmentFeedbackQuery({ reportId: REPORT_IDS.ASSESSMENT_REPORT_V2, clientId, submittedReportId: reportId });
  const [document, setDocument] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)

  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;

  const reportGoals = data?.assesmentData?.reportGoals;
  const reportRecommendations = data?.assesmentData?.reportRecommendations;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const caseApprentice = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }
  const assesmentData = data?.assesmentData

  const { data: disciplineAreas, isFetching: areasLoading } = useGetDisciplineAreasQuery(therapistDetails?.discipline_id, { skip: !therapistDetails?.discipline_id });
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

  const chartRefs = useRef([]);

  const therapist = useSelector((state) => state?.auth?.user)

  const initialValues = useMemo(() => {
    if (!data) return {};
    const guardianList = data?.assesment?.AssesmentGuardianAssigned?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
    let answers = data?.assesmentData?.reportAnswers;
    const [year, month, day] = data?.client_detail?.dob ? data?.client_detail?.dob.split("-") : "";
    const formattedDob = `${day}${month}${year}`;
    const password = `${data?.firstname}${data?.lastname}${formattedDob}`
    let values = {
      screening_date: data?.assesment?.screening_date || new Date(),
      apprentice_id: data?.assesment?.studentSignatureId,
      student: data?.assesment?.studentSignatureId ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.studentSignatureId } : null,
      signatureBy: data?.assesment?.signatureBy || null,
      guardianList,
      recommendation: data?.assesmentData?.reportRecommendations?.length ? data?.assesmentData?.reportRecommendations?.map((item) => ({ id: item?.id || null, answers: item?.answers, attachmentData: item?.attachmentData ? JSON.parse(item?.attachmentData) : [] })) : [{ answers: "" }],
      // emailFormData: {
      //   pdfPassword: password
      // }
      // observations: data?.assesmentData?.reportObservations?.length ? data?.assesmentData?.reportObservations?.map((item) => ({ notes: item?.notes || "", tracker_percentage: item?.tracker_percentage || 0, show_tracker: item?.show_tracker || "show", strategy: item?.AssessmentObservationStrategy?.length ? item?.AssessmentObservationStrategy?.map((strategy) => ({ answers: strategy?.answers == "null" ? "" : strategy?.answers || "", attachmentData: strategy?.attachmentData ? JSON.parse(strategy?.attachmentData) : [] })) : [{ answers: "", attachmentData: [] }] })) : [{ notes: "", tracker_percentage: 0, show_tracker: "show", strategy: [{ answers: "", attachmentData: [] }] }],
    };

    values = reportInitialValuesV2(values, reportQuestions, answers, data);

    return values;
  }, [data]);


  const validationSchema = useMemo(() => {
    return getValidationSchema(currentTab, reportQuestions)
  }, [reportQuestions, currentTab]);

  const handleSubmitStep = async (formValues) => {
    setSubmitting(true);

    try {
      const values = cloneDeep(formValues);
      let payload = formatReportFeedbackV2(reportHeading, reportQuestions, { ...values });

      let current_step = currentTab == 4 ? 'treatment_plans' : currentTab == 5 && "impressions"
      let body = {
        assesment_location: "in-person",
        feedbacks: payload.feedbacks,
        screening_date: values?.screening_date,
        report_heading: reportHeading,
        guardianList: values?.guardianList,
        recommendation: values?.recommendation,
        assessment_plans: values?.assessment_plans,
        treatment_plans: values?.treatment_plans?.length ? values?.treatment_plans?.map((item) => ({ goal_strategy_id: item?.id, strategies: item?.AssessmentGoalStrategyData })) : [],
        current_step: values?.saveForLater ? current_step : "submit_and_email",
        signatureBy: values?.signatureBy
      };

      body = getStepData(currentTab, body, values);

      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          ...body,
          studentSignatureId: values?.apprentice_id,
          save_for_later: "yes",
        }
      }
      else {

        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
          [...data.client_detail.client_guardian_mapping]
            .map((guardian) => {
              const id = guardian?.client_guardian?.id;
              const role = guardian?.client_guardian?.client_role?.title;

              const matchedGuardian = values?.guardianList?.find(
                (item) => item.id === id
              );

              if (matchedGuardian) {
                return {
                  ...guardian,
                  key: matchedGuardian?.role  // or matchedGuardian.role
                };
              }

              return null;
            })
            .filter(Boolean);

        const pdfData = {
          ...body,
          clientId: data?.id,
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.grade,
          schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
          schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians,
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format("MMMM D, YYYY"),
          reportQuestions: data?.assesmentData?.reportQuestions,
          reportAnswers: data?.assesmentData?.reportAnswers,
          assessmentGoals: reportGoals,
          images: chartImages,
          observations: values?.observations,
          recommendation: values?.recommendation,
          assessmentPlans: values?.assessment_plans,
          treatmentPlans: values?.treatment_plans,
          feedbacks: {
            [ASSESSMENT_REPORT_V2_QUESTIONS.summary]: values[ASSESSMENT_REPORT_V2_QUESTIONS.summary],
            [ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions]: values[ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions],
          },
        }

        const doc = (
          <AssessmentReportDocV2
            data={pdfData}
          />
        )

        // setDocument(doc)

        const filename = `Assessment Report - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          ...body,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: CLIENT_REPORT_TYPES[assessmentId]?.name || "Individual session report",
          }],
          emailFormData: values?.emailFormData,
        }
      }

      // await submissionHandler(body, formValues);

      const response = await submitReport({ data: body, clientId: assessmentAssignedId }).unwrap()
      refetch()
      setSubmitting(false);
      if (!values?.isAutoSave) {
        successMessageToast(response.message)
      }

      if (!values?.saveForLater) {
        // navigate(SCHOOL_CLIENT_LIST)
        navigate(SCHOOL_CLIENT_DETAIL.replace(":id", clientId))
      }
    } catch (error) {
      setSubmitting(false);
      console.error('error', error)
    }
  };

  const getStepData = (currentTab, body, values) => {
    let output = cloneDeep(body);
    switch (currentTab) {
      case 1:
        output = {
          ...output,
          current_step: "client_info",
        }
        break;
      case 2:
        output = {
          ...output,
          current_step: "background",
        }
        break;
      case 3:
        output = {
          ...output,
          current_step: "treatment_assessment",
        }
        break;
    }

    return output;
  }

  const handleViewPdf = async (values) => {
    const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
      [...data.client_detail.client_guardian_mapping]
        .map((guardian) => {
          const id = guardian?.client_guardian?.id;
          const role = guardian?.client_guardian?.client_role?.title;

          const matchedGuardian = values?.guardianList?.find(
            (item) => item.id === id
          );

          if (matchedGuardian) {
            return {
              ...guardian,
              key: matchedGuardian?.role  // or matchedGuardian.role
            };
          }

          return null;
        })
        .filter(Boolean);

    const pdfData = {
      clientId: data?.id,
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.grade,
      schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
      schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians,
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: moment(new Date()).format("MMMM D, YYYY"),
      reportQuestions: data?.assesmentData?.reportQuestions,
      reportAnswers: data?.assesmentData?.reportAnswers,
      assessmentGoals: reportGoals,
      images: chartImages,
      recommendation: values?.recommendation,
      assessmentPlans: values?.assessment_plans,
      treatmentPlans: values?.treatment_plans,
      feedbacks: {
        [ASSESSMENT_REPORT_V2_QUESTIONS.summary]: values[ASSESSMENT_REPORT_V2_QUESTIONS.summary],
        [ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions]: values[ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions],
      },
    }

    const doc = (
      <AssessmentReportDocV2
        data={pdfData}
      />
    )

    setDocument(doc)
    setPdfModal(true)

  };

  const handleCopyReportApi = async (reportId, assessmentId, screening_date) => {
    const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
    console.log('assessmentId for reort ', assessmentId)
    try {
      await copyReport({ clientId, clientType, reportId, reportType, assessmentId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
      navigate(generatePath(CLIENT_REPORTS_LIST, { clientId, clientType }))
    } catch (error) {
      console.log('error copying report:', error)
    }
  }
  const handleCopyReport = async (e, reportId, assessmentId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, assessmentId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  return (
    <>
      {copyReportLoading && <LoadingOverlay />}
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        isLoading={copyReportLoading}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        type='school'
      />
      <section className="ReportSec proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, validateForm }) => (
                <Form onSubmit={handleSubmit}>
                  {isLoading ? (
                    <LoadingIndicator />
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      <ViewPdfModal
                        publishPdfCheckbox={true}
                        show={pdfModal}
                        clientType={clientType}
                        setShow={setPdfModal}
                        doc={document}
                        handleSubmit={submitForm}
                        guardianList={data?.client_detail?.client_guardian_mapping}
                      />
                      <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                      <AutosaveReport
                        onAutosave={handleSubmitStep}
                        isFetching={isFetching}
                        delay={120000}
                      >
                        <Row>
                          <Col lg="12" className="my-2">
                            <div className="bg-white session-report" style={{ paddingBottom: "50px" }}>
                              <>
                                {(isFetching || submitting) && <LoadingOverlay />}

                                <div className="formBody reports-v2 pt-3">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>{therapist?.therapist_discipline?.name}</h5>
                                      <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Assessment Report</p>
                                    </div>
                                    <div>
                                      {
                                        [3, 4, 5].includes(currentTab) &&
                                        <button
                                          onClick={(e) => { handleCopyReport(e, reportId, assessmentId); setCurrentEntry({ id: reportId, assesment_type: assessmentId }) }}
                                          type="button"
                                          className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        >
                                          Make a Copy
                                        </button>
                                      }
                                    </div>
                                  </div>
                                  <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                                    <div className="d-flex gap_20">
                                      <div style={{ width: "145px" }}>
                                        <label style={{ fontSize: '14px', color: "#000" }} className="discharge-screen-label mb-1">DATE OF REPORT</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className="w-100 py-2"
                                          disabled={previewMode}
                                        />
                                      </div>
                                      {
                                        [2, 3, 4, 5].includes(currentTab) && (
                                          <div className="" style={{ width: "100%", marginTop: "3px" }}>
                                            <h6 className="date-title w-100">CLIENT INFORMATION</h6>
                                            <div className="d-flex text-dark align-items-center justify-content-between">
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>FIRST NAME</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.firstname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>LAST NAME</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.lastname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.client_detail?.city_town}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>DATE OF BIRTH</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{dateFormat(data?.client_detail?.dob, dobFormat)}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{data?.client_detail?.grade}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE</h5>
                                                <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{getAge(data?.client_detail?.dob)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <TabStepper
                                    currentTab={currentTab}
                                    steps={[
                                      "CLIENT INFO",
                                      "BACKGROUND",
                                      "ASSESSMENTS",
                                      "TREATMENT PLAN",
                                      "IMPRESSIONS",
                                    ]}
                                  />

                                  {currentTab === 1 ? (
                                    <div
                                      className="mt-4 client-view"
                                    >
                                      <ClientDetails
                                        showDOB
                                        data={data}
                                        heading="1. CLIENT INFORMATION"
                                      />
                                      <h5 className="section-title mt-5">2. SCHOOL INFORMATION</h5>
                                      <div className="mb-3 d-flex align-items-center gap_20">
                                        <div style={{ width: "33%" }}>
                                          <label className="discharge-screen-label">City/Town</label>
                                          <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.location} />
                                          {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.location}</div> */}
                                        </div>
                                        <div style={{ width: "33%" }}>
                                          <label className="discharge-screen-label">School Name</label>
                                          {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.name}</div> */}
                                          <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.name} />
                                        </div>
                                      </div>
                                      {data?.client_detail?.client_guardian_mapping?.[0]?.client_guardian ?
                                        [...data.client_detail.client_guardian_mapping] // clone the array
                                          .map((guardian, index) => {
                                            const slug = guardian?.client_guardian?.client_role?.slug;
                                            if (slug !== (clientType === "school" ? "teacher" : "parent")) {
                                              return null;
                                            }
                                            if ([0, 1].includes(index)) {
                                              return (
                                                <GuardianDetailList
                                                  previewMode={previewMode}
                                                  key={index}
                                                  index={index}
                                                  guardian={guardian}
                                                  slug={slug}
                                                  values={values}
                                                />
                                              );
                                            }
                                            else {
                                              return
                                            }
                                          }) : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />}
                                    </div>
                                  ) :
                                    currentTab === 2 ? (
                                      <div
                                        className="mt-1 session-info"
                                      >
                                        {reportQuestions?.length > 0 &&
                                          reportQuestions?.map((question, index) => {
                                            if ([
                                              ASSESSMENT_REPORT_V2_QUESTIONS.referral_reason,
                                              ASSESSMENT_REPORT_V2_QUESTIONS.background,
                                              ASSESSMENT_REPORT_V2_QUESTIONS.observation,
                                            ].includes(question.id)
                                            ) return (
                                              <div className="pt-4">
                                                <RenderQuestion
                                                  key={index}
                                                  characterLimit={1500}
                                                  question={question}
                                                  fieldName={question.id}
                                                  questionIndex={index + 1}
                                                />
                                              </div>
                                            );
                                          }
                                          )}
                                      </div>
                                    ) :
                                      currentTab === 3 ? (
                                        <div className="assessments">
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id === ASSESSMENT_REPORT_V2_QUESTIONS.assessment) {
                                                return (
                                                  <div className="my-3">
                                                    <QuestionAssessments
                                                      key={index}
                                                      question={question}
                                                      fieldName={"assessment_plans"}
                                                      questionIndex={1}
                                                      clientType={"school"}
                                                      assessmentId={assessmentId}
                                                    />
                                                  </div>
                                                );
                                              }
                                            })}
                                        </div>
                                      ) : currentTab === 4 ? (
                                        <div className="treatment-plans">
                                          <div style={{ backgroundColor: "rgba(147, 39, 143, 0.1)", borderRadius: "12px", marginTop: "16px" }}>
                                            <p className="section-title text-center" style={{ border: "0px", fontSize: "14px", fontStyle: "italic", padding: "19px" }}>
                                              Treatments are optional.
                                              <span style={{ fontWeight: 400 }}> <span style={{ textDecoration: "underline" }}>Skip this step</span> if you do not have a treatment to add to this report.</span>
                                            </p>
                                          </div>
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id === ASSESSMENT_REPORT_V2_QUESTIONS.treatment_plan) {
                                                return (
                                                  <div key={index} className={index === 0 ? "mt-0" : "mt-3"}>
                                                    <QuestionTreatmentPlan
                                                      refetchData={refetch}
                                                      key={index}
                                                      max={8}
                                                      maxRecommendations={4}
                                                      question={question}
                                                      fieldName={"treatment_plans"}
                                                      questionIndex={1}
                                                      clientType={"school"}
                                                      assessmentId={assessmentId}
                                                      assessmentAssignedId={assessmentAssignedId}
                                                      therapist={therapist}
                                                      dataFetching={isFetching}
                                                    />
                                                  </div>
                                                );
                                              }
                                            })}
                                        </div>
                                      ) : (
                                        <div className="recommendations">
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id == ASSESSMENT_REPORT_V2_QUESTIONS.summary || question.id == ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions) {
                                                return (
                                                  <div className="pt-4">
                                                    <RenderQuestion
                                                      key={index}
                                                      question={question}
                                                      fieldName={question.id}
                                                    // questionIndex={index + 1}
                                                    />
                                                  </div>
                                                )
                                              }
                                              if (question.id == ASSESSMENT_REPORT_V2_QUESTIONS.recommendations) {
                                                return (
                                                  <div className="py-4">
                                                    {(
                                                      <h6 className="section-title w-100" style={{ marginBottom: "7px" }}>
                                                        {question?.question}
                                                      </h6>
                                                    )}
                                                    <QuestionMultipleRecommendation
                                                      key={index}
                                                      question={question}
                                                      fieldName={question.id}
                                                      fieldData={reportRecommendations}
                                                      questionIndex={1}
                                                      clientType={"school"}
                                                      assessmentId={assessmentId}
                                                      maxRecommendations={4}
                                                    />
                                                    <div className="mb-2 mt-5">
                                                      <h6 className="section-title text-uppercase">
                                                        2. signature
                                                      </h6>
                                                      <ApprenticeSelect
                                                        name={"student"}
                                                        caseApprentice={caseApprentice}
                                                      />
                                                    </div>
                                                    {/* <RenderQuestion
                                                      key={index}
                                                      question={question}
                                                      fieldName={question.id}
                                                      fieldData={reportRecommendations}
                                                      questionIndex={1}
                                                      clientType={"school"}
                                                      assessmentId={assessmentId}
                                                    /> */}
                                                  </div>
                                                );
                                              };
                                            }
                                            )}
                                          {/* <div className="mb-2">
                                            <h6 className="section-title text-uppercase">
                                              2. signature
                                            </h6>
                                            <div className="d-flex gap-2 mt-2 align-items-center">
                                              <input
                                                type="checkbox"
                                                className="form-check"
                                                style={{ accentColor: "#b46c9f", height: 20, width: 20 }}
                                                disabled={previewMode}
                                                onChange={(e) => {
                                                  if (values?.student?.value) {
                                                    setFieldValue('apprentice_id', e.target.checked ? caseApprentice?.id : null);
                                                  }
                                                  else {
                                                    errorMessageToast("Please select the apprentice")
                                                  }
                                                }}
                                                checked={values.apprentice_id === caseApprentice?.id}
                                              />
                                              <div className="d-flex student-cstm-select flex-1 w-100 gap-2 align-items-center">
                                                <span className="proxima" style={{ fontSize: "14px" }}>Add Student:</span>
                                                <Col md='4'>
                                                  <AppSelect2Field
                                                    name='student'
                                                    option={caseApprentice?.therapist_id ? [{ label: userFullName(caseApprentice?.caseTherapist), value: caseApprentice?.therapist_id }] : []}
                                                    placeholder="Select a student..."
                                                    classNamePrefix="khan"
                                                  />
                                                </Col>
                                              </div>
                                            </div>
                                          </div> */}
                                        </div>
                                      )
                                  }
                                </div>
                              </>
                            </div>
                          </Col>
                          {/* <button type="button" onClick={() => getExample()}>
                            VIEW IMAGE
                          </button> */}
                          <Col lg="12" className="my-2">
                            <ReportError />
                            <div className='d-flex gap-3 align-items-center justify-content-between'>
                              <div>
                                {currentTab > 1 && (
                                  <button
                                    onClick={() => setCurrentTab(currentTab - 1)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    <ArrowLeftIcon />
                                    {"Back"}
                                  </button>
                                )}
                              </div>
                              <div className="d-flex gap-3 align-items-center justify-content-between">
                                <ReportSubmitButton
                                  onClick={() => setFieldValue('saveForLater', true)}
                                  type="submit"
                                  className="d-flex gap-2 align-items-center justify-content-center save-discharge-screen"
                                  disabled={previewMode || isFetching || submitting}
                                // isLoading={submitReportLoading || submitting}
                                >
                                  Save
                                  {/* {<img width={13} height={6} src={down_arrow_img} alt="down_arrow_img" />} */}
                                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                                  </svg>
                                </ReportSubmitButton>
                                {currentTab === 5 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                      // isLoading={submittingStep}
                                      disabled={isFetching || submitting}
                                      onClick={() => handleViewPdf(values)}
                                    >
                                      {/* <img width={16} height={14} src={preview_img} alt="preview_img" /> */}
                                      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                      </svg>
                                      Preview Report
                                    </button>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        SUBMIT
                                        {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                      </ReportSubmitButton>
                                    }
                                  </>
                                ) : (
                                  <button
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (isEmpty(errors)) {
                                        setFieldValue('saveForLater', true);
                                        await submitForm();
                                        setCurrentTab(currentTab + 1);
                                      }
                                    }}
                                    type="submit"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting || (currentTab == 3 && !values["assessment_plans"]?.length) /*|| (currentTab == 4 && !values["treatment_plans"]?.length)*/}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Next
                                    {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                    </svg>
                                  </button>
                                )}
                                {/* {
                                  data?.assesment?.status != 'submitted'
                                  &&
                                  <>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        onClick={() => setFieldValue('saveForLater', false)}
                                        type="submit"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={previewMode || isFetching || submitting}
                                      >
                                        SUBMIT & Export
                                        <img width={14} height={8} src={arro_right_img} alt="arro_right_img" />
                                      </ReportSubmitButton>
                                    }
                                  </>
                                } */}
                              </div>
                            </div>
                          </Col>

                        </Row>
                      </AutosaveReport>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Container>
      </section >
    </>
  );
};

export default SchoolAssessmentReport;